import script from "./CookieFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./CookieFooter.vue?vue&type=script&setup=true&lang=js"

import "./CookieFooter.vue?vue&type=style&index=0&id=c8a0cf46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8a0cf46"]])

export default __exports__